<div
  ngpProgress
  class="sui-progress"
  [ngpProgressValue]="value"
  [ngpProgressMin]="min"
  [ngpProgressMax]="max"
  [attr.data-variant]="variant"
  [attr.data-size]="size"
>
  <!-- Width is set by the primitive via [style.width.%]; we style colour/height only. -->
  <div ngpProgressIndicator class="sui-progress__indicator"></div>
</div>
